import { render, staticRenderFns } from "./CrmRecipientMessages.vue?vue&type=template&id=2ff723cc&scoped=true"
import script from "./CrmRecipientMessages.vue?vue&type=script&lang=js"
export * from "./CrmRecipientMessages.vue?vue&type=script&lang=js"
import style0 from "./CrmRecipientMessages.vue?vue&type=style&index=0&id=2ff723cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff723cc",
  null
  
)

export default component.exports